export default __webpack_public_path__ + "static/media/brewery-logos.f0e2f8d9.png";